import styled from 'styled-components';
import { mixins } from '../../css';

export const ToDoCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid black;
  padding-bottom: ${mixins.pxToRem(12)};
  padding-top: ${mixins.pxToRem(8)};
  padding-left: ${mixins.pxToRem(10)};
  padding-right: ${mixins.pxToRem(10)};
  ${({ theme }) => `border-bottom-color: ${theme.lightText}`};
`;
